/**
 * Messages API
 */
export default class Messages {
  constructor(axios) {
    this.$axios = axios
  }

  ListConversations() {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: '/messages/conversations',
      })
        .then(({ data }) => {
          resolve(data.conversations)
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }
}
